import { connect } from "react-redux";
import { searchSelector, searchActions as actions } from "./search-reducer";

export function searchComposer(Component) {
    const mapStateToProps = function (state) {
        return {
            query: searchSelector.query(state),
            pending: searchSelector.pending(state),
            contentSearchResults: searchSelector.contentSearchResults(state),
            contentSearchPage: searchSelector.contentSearchPage(state),
            contentSearchHasPrevious: searchSelector.contentSearchHasPrevious(state),
            contentSearchHasNext: searchSelector.contentSearchHasNext(state),
            contentSearchTotalCount: searchSelector.contentSearchTotalCount(state),

            productSearchResults: searchSelector.productSearchResults(state),
            productSearchPage: searchSelector.productSearchPage(state),
            productSearchHasPrevious: searchSelector.productSearchHasPrevious(state),
            productSearchHasNext: searchSelector.productSearchHasNext(state),
            productSearchTotalCount: searchSelector.productSearchTotalCount(state)
        };
    };

    const mapDispatchToProps = function (dispatch) {
        return {
            queryChanged: query => dispatch(actions.queryChanged(query)),
            searchSubmit: propsObj => dispatch(actions.searchSubmit(propsObj)),

            contentSearchPrevious: () => dispatch(actions.contentSearchPrevious()),
            contentSearchNext: () => dispatch(actions.contentSearchNext()),
            contentSearchSubmit: () => dispatch(actions.contentSearchSubmit()),

            productSearchPrevious: () => dispatch(actions.productSearchPrevious()),
            productSearchNext: () => dispatch(actions.productSearchNext()),
            productSearchSubmit: () => dispatch(actions.productSearchSubmit())
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(Component);
}
